var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isUserLoaded)?_c('link-header',{attrs:{"header-data":_vm.headerDetails,"use-internal-routes":true},on:{"segmentationselected":_vm.changeBookingSystem,"languageselected":_vm.changeLanguage}}):_vm._e(),_c('postalCodeModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }